module.exports = __webpack_public_path__ + "assets/icon-conductor-tape20.bb6e9c6d.svg";